import type { CountryCode } from "libphonenumber-js";

export interface RegionConfig {
  contactUrl: string;
  termsUrl: string;
  privacyUrl: string;
  supportPhone: string;
  supportPhoneDisplay: string;
  phoneCountryCode: CountryCode;
}

const AU_CONFIG: RegionConfig = {
  contactUrl: "https://www.visioni.com.au/contact",
  termsUrl: "https://www.visioni.com.au/privacy-policy",
  privacyUrl:
    "https://cdn.prod.website-files.com/6643c898749ce3b110deb53f/66d6b4f5a8f100f2e932f217_136c9d871abc4e278aa5cd2066cf4c77_4.2-051A_FR_Terms_Conditions_Aus_Vision_Intelligence_07_2023.pdf",
  supportPhone: "131714",
  supportPhoneDisplay: "13 17 14",
  phoneCountryCode: "AU",
};

const NZ_CONFIG: RegionConfig = {
  contactUrl: "https://www.visioni.co.nz/contact",
  termsUrl: "https://www.visioni.co.nz/terms-and-conditions",
  privacyUrl: "https://www.visioni.co.nz/privacy-policy",
  supportPhone: "0800131714",
  supportPhoneDisplay: "0800 13 17 14",
  phoneCountryCode: "NZ",
};

const REGION_CONFIGS: Record<string, RegionConfig> = {
  AU: AU_CONFIG,
  NZ: NZ_CONFIG,
};

export const DEFAULT_REGION = "AU";

export function getRegionConfig(countryCode: string): RegionConfig {
  return REGION_CONFIGS[countryCode.toUpperCase()] ?? REGION_CONFIGS[DEFAULT_REGION];
}
